import React from 'react'
import { useTranslation } from 'react-i18next';
import Block from '../../../components/Block';
import Title from '../../../components/Title';

const CmpRequestAccess = () => {
  const { t } = useTranslation();
  return ( <>
    <Title main={t("menu.cmp")} sub={t("cmp.unconfigured.title")}/>
    <Block>
      {t("cmp.unconfigured.message")}
    </Block>
  </> );
}
 
export default CmpRequestAccess;